
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as MapActions from '../../map.actions'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
import * as IndicatorsActions from '../../../Indicators/indicators.actions'
import * as battlesActions from '../../../Battles/battles.actions'

import * as MapSelectors from '../../map.selectors'
import * as PhasesSelectors from '../../../Phases/phases.selectors'

import { seeds } from '../../seeds'

import { Game, Firebase } from '../../../../Core'
import View from './View'

const mapDispatchToProps = (dispatch) => ({
  selectCurrentTile: bindActionCreators(MapActions.selectCurrentTile, dispatch),
  setDisplayType: bindActionCreators(IndicatorsActions.setDisplayType, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  showError: bindActionCreators(Game.actions.showError, dispatch),
  hideError: bindActionCreators(Game.actions.hideError, dispatch),
  mapLoaded: bindActionCreators(MapActions.mapLoaded, dispatch),
  mapLoadError: bindActionCreators(MapActions.mapLoadError, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  getBattle: bindActionCreators(battlesActions.getBattle, dispatch),
  clearSprites: bindActionCreators(MapActions.clearSprites, dispatch),
})

const mapStateToProps = (state) => ({
  seeds: seeds,
  zoomLevels: MapSelectors.getZooms(state),
  allAnimations: MapSelectors.getAnimations(state),
  userMap: MapSelectors.getUserMap(state),
  visitorMap: MapSelectors.getVisitorMap(state),
  terrainAtlas: MapSelectors.getAtlas(state),
  phaseInfo: PhasesSelectors.getPhasesInfo(state),
  isAttacking: MapSelectors.getAttackState(state),
  visitorInfo: MapSelectors.getVisitorInfo(state),
  listenerType: Firebase.selectors.getListenerType(state),
  isTutorial: false,
})

export default connect(mapStateToProps, mapDispatchToProps)(View)
